{{#each warnings}}
<div class="row">
	<div class="col-xs-12">
		<div class="alert alert-info">
			<strong>{{title}}</strong> {{info}}</div>
		</div>
	</div>
</div>
{{/each}}